import {FaqDto} from "../../../services/Client";

export const reorder = (list: FaqDto[], startIndex: number, endIndex: number): FaqDto[] => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};



// WEBPACK FOOTER //
// ./src/views/AdminView/FaqTab/FaqUtils.ts